(function () {
  "use strict";

  const rootRoute =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function money(cents) {
    const currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "USD";
    const locale = document.documentElement.lang || "en-US";
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return "$" + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(
      /[&<>'"]/g,
      function (character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          "'": "&#39;",
          '"': "&quot;",
        }[character];
      },
    );
  }

  function imageUrlWithWidth(value, width) {
    try {
      const url = new URL(value, window.location.origin);
      url.searchParams.set("width", String(width));
      return url.href;
    } catch (_error) {
      return value;
    }
  }

  function initMenu() {
    const root = document.querySelector("[data-mobile-menu]");
    const openButton = document.querySelector("[data-menu-open]");
    if (!root || !openButton || root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const focusable = Array.from(
      root.querySelectorAll("[data-menu-close], [data-menu-link]"),
    );

    function setTabIndex(value) {
      focusable.forEach(function (element) {
        element.tabIndex = value;
      });
    }

    function openMenu() {
      root.classList.add("open");
      root.setAttribute("aria-hidden", "false");
      openButton.classList.add("active");
      openButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("menu-open");
      setTabIndex(0);
      const closeButton = root.querySelector("[data-menu-close]");
      if (closeButton) closeButton.focus();
    }

    function closeMenu() {
      root.classList.remove("open");
      root.setAttribute("aria-hidden", "true");
      openButton.classList.remove("active");
      openButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("menu-open");
      setTabIndex(-1);
    }

    openButton.addEventListener("click", openMenu);
    root
      .querySelectorAll("[data-menu-close], [data-menu-link]")
      .forEach(function (element) {
        element.addEventListener("click", closeMenu);
      });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("open"))
        closeMenu();
    });
  }

  function initProductGalleries(scope) {
    (scope || document)
      .querySelectorAll("[data-product-gallery]:not([data-initialized])")
      .forEach(function (gallery) {
        gallery.dataset.initialized = "true";
        const panels = Array.from(
          gallery.querySelectorAll("[data-gallery-panel]"),
        );
        const thumbs = Array.from(
          gallery.querySelectorAll("[data-gallery-thumb]"),
        );
        const counter = gallery.querySelector("[data-gallery-counter]");
        const label = gallery.querySelector("[data-gallery-label-display]");
        const detail = gallery.querySelector("[data-gallery-detail-display]");
        const caption = gallery.querySelector("[data-gallery-caption-display]");
        const stage = gallery.querySelector("[data-gallery-stage]");
        const thumbnailRail = gallery.querySelector(".gallery-thumbnails");
        let activeIndex = 0;
        let touchStart = null;

        function centerActiveThumbnail(thumb) {
          if (!thumbnailRail || !thumb) return;
          const targetLeft =
            thumb.offsetLeft -
            (thumbnailRail.clientWidth - thumb.offsetWidth) / 2;
          const maxLeft = Math.max(
            0,
            thumbnailRail.scrollWidth - thumbnailRail.clientWidth,
          );
          const left = Math.min(Math.max(targetLeft, 0), maxLeft);
          if (typeof thumbnailRail.scrollTo === "function") {
            thumbnailRail.scrollTo({
              left: left,
              behavior: reduceMotion.matches ? "auto" : "smooth",
            });
          } else {
            thumbnailRail.scrollLeft = left;
          }
        }

        function setActive(nextIndex) {
          if (!panels.length) return;
          activeIndex = (nextIndex + panels.length) % panels.length;
          panels.forEach(function (panel, index) {
            const active = index === activeIndex;
            panel.hidden = !active;
            panel.classList.toggle("active", active);
            panel.setAttribute("aria-hidden", String(!active));
          });
          thumbs.forEach(function (thumb, index) {
            const active = index === activeIndex;
            thumb.classList.toggle("active", active);
            thumb.setAttribute("aria-selected", String(active));
            thumb.tabIndex = active ? 0 : -1;
          });
          const panel = panels[activeIndex];
          if (counter)
            counter.textContent =
              String(activeIndex + 1).padStart(2, "0") +
              " / " +
              String(panels.length).padStart(2, "0");
          if (label)
            label.textContent = panel.dataset.galleryLabel || "PRODUCT VIEW";
          if (detail) detail.textContent = panel.dataset.galleryDetail || "";
          if (caption) caption.textContent = panel.dataset.galleryCaption || "";
          centerActiveThumbnail(thumbs[activeIndex]);
        }

        thumbs.forEach(function (thumb, index) {
          thumb.addEventListener("click", function () {
            setActive(index);
          });
          thumb.addEventListener("keydown", function (event) {
            if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
            event.preventDefault();
            const offset = event.key === "ArrowRight" ? 1 : -1;
            setActive(index + offset);
            if (thumbs[activeIndex]) thumbs[activeIndex].focus();
          });
        });
        const previous = gallery.querySelector("[data-gallery-prev]");
        const next = gallery.querySelector("[data-gallery-next]");
        if (previous)
          previous.addEventListener("click", function () {
            setActive(activeIndex - 1);
          });
        if (next)
          next.addEventListener("click", function () {
            setActive(activeIndex + 1);
          });
        if (stage) {
          stage.addEventListener("pointerdown", function (event) {
            if (event.target.closest("video, model-viewer")) return;
            touchStart = event.clientX;
          });
          stage.addEventListener("pointerup", function (event) {
            if (touchStart == null) return;
            const delta = event.clientX - touchStart;
            touchStart = null;
            if (Math.abs(delta) > 45)
              setActive(activeIndex + (delta < 0 ? 1 : -1));
          });
        }
        setActive(0);
      });
  }

  function initProductForms(scope) {
    (scope || document)
      .querySelectorAll("[data-product-form]:not([data-initialized])")
      .forEach(function (form) {
        form.dataset.initialized = "true";
        const variantInput = form.querySelector("[data-variant-input]");
        const variantSelect = form.querySelector("[data-variant-select]");
        const sellingPlanInput = form.querySelector(
          "[data-selling-plan-input]",
        );
        const quantityInput = form.querySelector("[data-quantity-input]");
        const quantityDisplay = form.querySelector("[data-quantity-display]");
        const addButton = form.querySelector("[data-add-to-cart]");
        const addLabel = form.querySelector("[data-add-label]");
        const totalNode = form.querySelector("[data-product-total]");
        const status = form.querySelector("[data-product-form-status]");
        const planButtons = Array.from(
          form.querySelectorAll("[data-plan-option]"),
        );
        let quantity = Number(quantityInput && quantityInput.value) || 1;
        let activePlan = planButtons.some(function (button) {
          return (
            button.dataset.planOption === "subscribe" &&
            button.classList.contains("selected")
          );
        })
          ? "subscribe"
          : "once";

        function variantData() {
          if (!variantSelect) {
            const onceButton = form.querySelector('[data-plan-option="once"]');
            const subscribeButton = form.querySelector(
              '[data-plan-option="subscribe"]',
            );
            return {
              id: variantInput ? variantInput.value : "",
              price: Number(
                (onceButton && onceButton.dataset.price) ||
                  (totalNode && totalNode.dataset.unitPrice) ||
                  0,
              ),
              available: addButton ? !addButton.disabled : true,
              subscriptionId:
                (subscribeButton && subscribeButton.dataset.sellingPlanId) ||
                "",
              subscriptionPrice: Number(
                (subscribeButton && subscribeButton.dataset.price) || 0,
              ),
            };
          }
          const option = variantSelect.selectedOptions[0];
          return {
            id: option.value,
            price: Number(option.dataset.price || 0),
            available: option.dataset.available === "true",
            subscriptionId: option.dataset.subscriptionId || "",
            subscriptionPrice: Number(option.dataset.subscriptionPrice || 0),
          };
        }

        function update() {
          const variant = variantData();
          if (variantInput) variantInput.value = variant.id;
          const subscribeButton = form.querySelector(
            '[data-plan-option="subscribe"]',
          );
          const onceButton = form.querySelector('[data-plan-option="once"]');
          if (subscribeButton && variantSelect) {
            subscribeButton.dataset.sellingPlanId = variant.subscriptionId;
            subscribeButton.dataset.price = String(
              variant.subscriptionPrice || variant.price,
            );
            subscribeButton.hidden = !variant.subscriptionId;
            const priceNode = subscribeButton.querySelector("[data-plan-price]");
            if (priceNode)
              priceNode.textContent = money(
                variant.subscriptionPrice || variant.price,
              );
          }
          if (onceButton && variantSelect) {
            onceButton.dataset.price = String(variant.price);
            const priceNode = onceButton.querySelector("[data-plan-price]");
            if (priceNode) priceNode.textContent = money(variant.price);
          }
          if (activePlan === "subscribe" && !variant.subscriptionId)
            activePlan = "once";
          planButtons.forEach(function (button) {
            const selected = button.dataset.planOption === activePlan;
            button.classList.toggle("selected", selected);
            button.setAttribute("aria-checked", String(selected));
          });
          if (sellingPlanInput) {
            sellingPlanInput.disabled =
              activePlan !== "subscribe" || !variant.subscriptionId;
            sellingPlanInput.value =
              activePlan === "subscribe" ? variant.subscriptionId : "";
          }
          if (quantityInput) quantityInput.value = String(quantity);
          if (quantityDisplay) quantityDisplay.textContent = String(quantity);
          const unitPrice =
            activePlan === "subscribe" && variant.subscriptionId
              ? variant.subscriptionPrice
              : variant.price;
          if (totalNode) {
            totalNode.dataset.unitPrice = String(unitPrice);
            totalNode.textContent = money(unitPrice * quantity);
          }
          if (addButton) addButton.disabled = !variant.available;
          if (addLabel)
            addLabel.textContent = variant.available
              ? activePlan === "subscribe"
                ? "SUBSCRIBE"
                : "ADD TO BAG"
              : "SOLD OUT";
          if (form.classList.contains("movr-product-form--product")) {
            const mobilePrice = document.querySelector("[data-mobile-price]");
            if (mobilePrice) mobilePrice.textContent = money(unitPrice);
          }
        }

        planButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            activePlan = button.dataset.planOption;
            update();
          });
        });
        if (variantSelect) variantSelect.addEventListener("change", update);
        const minus = form.querySelector("[data-quantity-minus]");
        const plus = form.querySelector("[data-quantity-plus]");
        if (minus)
          minus.addEventListener("click", function () {
            quantity = Math.max(1, quantity - 1);
            update();
          });
        if (plus)
          plus.addEventListener("click", function () {
            quantity += 1;
            update();
          });

        form.addEventListener("submit", async function (event) {
          event.preventDefault();
          if (!addButton || addButton.disabled) return;
          addButton.classList.add("loading");
          if (status) status.textContent = "";
          try {
            const response = await fetch(rootRoute + "cart/add.js", {
              method: "POST",
              headers: { Accept: "application/json" },
              body: new FormData(form),
            });
            const result = await response.json();
            if (!response.ok)
              throw new Error(
                result.description || "This item could not be added.",
              );
            await refreshCart();
            openCart();
          } catch (error) {
            if (status)
              status.textContent =
                error.message || "This item could not be added.";
          } finally {
            addButton.classList.remove("loading");
          }
        });
        update();
      });

    (scope || document)
      .querySelectorAll("[data-mobile-product-submit]:not([data-initialized])")
      .forEach(function (button) {
        button.dataset.initialized = "true";
        button.addEventListener("click", function () {
          const form = document.getElementById(button.dataset.formId);
          if (form) form.requestSubmit();
        });
      });
  }

  const cartDrawer = function () {
    return document.querySelector("[data-cart-drawer]");
  };
  const cartOverlay = function () {
    return document.querySelector(".drawer-overlay");
  };

  function openCart() {
    const drawer = cartDrawer();
    const overlay = cartOverlay();
    if (!drawer || !overlay) return;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    overlay.classList.add("visible");
    overlay.tabIndex = 0;
    document.body.classList.add("cart-open");
    const close = drawer.querySelector("[data-cart-close]");
    if (close) close.focus();
  }

  function closeCart() {
    const drawer = cartDrawer();
    const overlay = cartOverlay();
    if (!drawer || !overlay) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    overlay.classList.remove("visible");
    overlay.tabIndex = -1;
    document.body.classList.remove("cart-open");
  }

  function cartItemHtml(item) {
    const image = item.image
      ? '<img src="' +
        escapeHtml(imageUrlWithWidth(item.image, 180)) +
        '" alt="" width="90" height="110" loading="lazy">'
      : "<b>MOVR</b><span>KEEP GOING.</span>";
    const plan =
      item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.name
        : "ONE-TIME";
    const variant =
      item.variant_title && item.variant_title !== "Default Title"
        ? item.variant_title
        : "LEMON";
    return (
      '<div class="cart-item" data-cart-line data-key="' +
      escapeHtml(item.key) +
      '">' +
      '<div class="cart-mini-product">' +
      image +
      "</div>" +
      '<div class="cart-item-copy"><div><h3>' +
      escapeHtml(item.product_title) +
      '</h3><button type="button" data-cart-remove data-key="' +
      escapeHtml(item.key) +
      '">REMOVE</button></div>' +
      "<p>" +
      escapeHtml(variant) +
      " · " +
      escapeHtml(plan) +
      '</p><div class="cart-item-bottom"><div class="quantity small"><button type="button" data-cart-quantity="' +
      Math.max(0, item.quantity - 1) +
      '" data-key="' +
      escapeHtml(item.key) +
      '" aria-label="Decrease quantity">−</button><span>' +
      item.quantity +
      '</span><button type="button" data-cart-quantity="' +
      (item.quantity + 1) +
      '" data-key="' +
      escapeHtml(item.key) +
      '" aria-label="Increase quantity">+</button></div><strong>' +
      money(item.final_line_price) +
      "</strong></div></div></div>"
    );
  }

  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = cart.item_count;
    });
    const itemLabel = document.querySelector("[data-cart-item-label]");
    if (itemLabel)
      itemLabel.textContent =
        cart.item_count + " ITEM" + (cart.item_count === 1 ? "" : "S");
    const content = document.querySelector("[data-cart-content]");
    if (!content) return;
    if (!cart.item_count) {
      content.innerHTML =
        '<div class="empty-cart"><span>0 / 03</span><h3>NOTHING<br>MOVING YET.</h3><p>Add your daily performance mix and get going.</p><a class="button button-yellow" href="' +
        rootRoute +
        'collections/all">SHOP MOVR</a></div>';
      return;
    }
    const unlocked = cart.item_count >= 2;
    content.innerHTML =
      '<div class="shipping-progress"><p>' +
      (unlocked
        ? "You unlocked free U.S. shipping."
        : "Add one more tub for free U.S. shipping.") +
      '</p><span><i style="width:' +
      (unlocked ? 100 : 50) +
      '%"></i></span></div>' +
      cart.items.map(cartItemHtml).join("") +
      '<div class="drawer-total"><div><span>SUBTOTAL</span><strong>' +
      money(cart.total_price) +
      '</strong></div><p>Shipping and taxes calculated at checkout.</p><form class="cart-checkout-form" action="' +
      escapeHtml(rootRoute + "cart") +
      '" method="post"><button class="button button-yellow" type="submit" name="checkout">SECURE CHECKOUT <span><svg class="ui-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"></path><path d="m14 7 5 5-5 5"></path></svg></span></button></form><span class="drawer-safe">◈ 30-DAY KEEP-GOING PROMISE</span></div>';
  }

  async function refreshCart() {
    const response = await fetch(rootRoute + "cart.js", {
      headers: { Accept: "application/json" },
    });
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  async function changeCart(key, quantity) {
    const response = await fetch(rootRoute + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: Number(quantity) }),
    });
    const cart = await response.json();
    if (!response.ok)
      throw new Error(cart.description || "The bag could not be updated.");
    renderCart(cart);
  }

  function initCart() {
    if (document.body.dataset.cartInitialized) return;
    document.body.dataset.cartInitialized = "true";
    document.addEventListener("click", function (event) {
      const open = event.target.closest("[data-cart-open]");
      const close = event.target.closest("[data-cart-close]");
      const remove = event.target.closest("[data-cart-remove]");
      const quantity = event.target.closest("[data-cart-quantity]");
      if (open) {
        event.preventDefault();
        openCart();
      }
      if (close) {
        event.preventDefault();
        closeCart();
      }
      if (remove) {
        event.preventDefault();
        changeCart(remove.dataset.key, 0).catch(function () {});
      }
      if (quantity) {
        event.preventDefault();
        changeCart(quantity.dataset.key, quantity.dataset.cartQuantity).catch(
          function () {},
        );
      }
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeCart();
    });
  }

  function initReviews(scope) {
    (scope || document)
      .querySelectorAll("[data-reviews-section]:not([data-initialized])")
      .forEach(function (section) {
        section.dataset.initialized = "true";
        const toggle = section.querySelector("[data-review-form-toggle]");
        const form = section.querySelector("[data-review-form]");
        const cards = Array.from(
          section.querySelectorAll("[data-review-card]"),
        );
        const load = section.querySelector("[data-review-load]");
        const count = section.querySelector("[data-review-visible]");
        const allLoaded = section.querySelector("[data-reviews-all]");
        let visible = Math.min(6, cards.length);

        function showForm(forceOpen) {
          if (!form || !toggle) return;
          const open = typeof forceOpen === "boolean" ? forceOpen : form.hidden;
          form.hidden = !open;
          toggle.setAttribute("aria-expanded", String(open));
          toggle.firstChild.nodeValue = open
            ? "CLOSE FORM "
            : "WRITE A REVIEW ";
          if (open)
            form.scrollIntoView({
              behavior: reduceMotion.matches ? "auto" : "smooth",
              block: "nearest",
            });
        }
        if (toggle)
          toggle.addEventListener("click", function () {
            showForm();
          });
        if (form && form.querySelector(".review-thanks")) showForm(true);

        function updateCards() {
          cards.forEach(function (card, index) {
            card.hidden = index >= visible;
          });
          if (count) count.textContent = visible;
          const done = visible >= cards.length;
          if (load) load.hidden = done;
          if (allLoaded) allLoaded.hidden = !done;
        }
        if (load)
          load.addEventListener("click", function () {
            visible = Math.min(visible + 6, cards.length);
            updateCards();
          });
        section
          .querySelectorAll(".review-rating-input input")
          .forEach(function (input) {
            input.addEventListener("change", function () {
              const selected = Number(input.value.split(" ")[0]);
              section
                .querySelectorAll(".review-rating-input label")
                .forEach(function (label, index) {
                  label.classList.toggle("selected", index < selected);
                });
            });
          });
        updateCards();
      });
  }

  const quizQuestions = [
    {
      prompt: "HOW DO YOU MOVE MOST?",
      context: "Pick the activity you do most often.",
      icon: "power",
      options: [
        {
          title: "Lifting or climbing",
          detail: "Hard moves with short breaks.",
          scores: { power: 3, hydration: 1, simplicity: 0 },
        },
        {
          title: "Hiking or long sessions",
          detail: "Long movement where water matters.",
          scores: { power: 1, hydration: 3, simplicity: 0 },
        },
        {
          title: "A mix of everything",
          detail: "Gym, trails, sports, and active days.",
          scores: { power: 2, hydration: 2, simplicity: 1 },
        },
        {
          title: "Everyday active life",
          detail: "Simple support for busy days.",
          scores: { power: 1, hydration: 1, simplicity: 3 },
        },
      ],
    },
    {
      prompt: "WHAT USUALLY RUNS OUT FIRST?",
      context: "Pick what gets harder first.",
      icon: "hydration",
      options: [
        {
          title: "Power",
          detail: "Later sets or moves feel weaker.",
          scores: { power: 3, hydration: 0, simplicity: 0 },
        },
        {
          title: "Hydration",
          detail: "Heat and sweat take a lot out of me.",
          scores: { power: 0, hydration: 3, simplicity: 0 },
        },
        {
          title: "Consistency",
          detail: "I forget to follow my routine.",
          scores: { power: 1, hydration: 0, simplicity: 3 },
        },
        {
          title: "Keeping it simple",
          detail: "I use too many separate products.",
          scores: { power: 0, hydration: 1, simplicity: 3 },
        },
      ],
    },
    {
      prompt: "HOW DEMANDING IS YOUR SWEAT?",
      context: "Think about your usual workout or active day.",
      icon: "hydration",
      options: [
        {
          title: "Light",
          detail: "Short, cool, or not very sweaty.",
          scores: { power: 1, hydration: 1, simplicity: 0 },
        },
        {
          title: "Medium",
          detail: "I can clearly feel and see sweat.",
          scores: { power: 0, hydration: 2, simplicity: 0 },
        },
        {
          title: "Heavy or salty",
          detail: "Hot, long, or very sweaty.",
          scores: { power: 0, hydration: 4, simplicity: 0 },
        },
        {
          title: "It changes",
          detail: "Every day and activity feels different.",
          scores: { power: 0, hydration: 2, simplicity: 2 },
        },
      ],
    },
    {
      prompt: "WHAT IS IN YOUR ROUTINE NOW?",
      context: "Tell us what you already take.",
      icon: "daily",
      options: [
        {
          title: "Neither",
          detail: "I do not use either one each day.",
          scores: { power: 2, hydration: 2, simplicity: 2 },
        },
        {
          title: "Creatine only",
          detail: "Hydration support is separate or missing.",
          scores: { power: 0, hydration: 3, simplicity: 2 },
        },
        {
          title: "Electrolytes only",
          detail: "Creatine is separate or missing.",
          scores: { power: 3, hydration: 0, simplicity: 2 },
        },
        {
          title: "Both, but separately",
          detail: "I want fewer scoops and containers.",
          scores: { power: 1, hydration: 1, simplicity: 4 },
        },
      ],
    },
    {
      prompt: "WHAT WOULD MAKE THE HABIT STICK?",
      context: "Pick what would make daily use easier.",
      icon: "daily",
      options: [
        {
          title: "One daily scoop",
          detail: "Fewer products and fewer steps.",
          scores: { power: 1, hydration: 1, simplicity: 4 },
        },
        {
          title: "A clean taste",
          detail: "Something crisp and easy to drink.",
          scores: { power: 0, hydration: 2, simplicity: 3 },
        },
        {
          title: "A set time",
          detail: "Take it before, during, or after movement.",
          scores: { power: 2, hydration: 1, simplicity: 2 },
        },
        {
          title: "Automatic refills",
          detail: "I do not want to remember to reorder.",
          scores: { power: 0, hydration: 0, simplicity: 4 },
        },
      ],
    },
  ];

  const quizProfiles = {
    power: {
      kicker: "YOUR TOP GOAL / HARD EFFORT",
      title: "YOUR SIMPLE POWER PLAN.",
      body: "Hard, repeated effort matters most to you. Daily creatine supports strength and power. MOVR adds electrolytes in the same scoop.",
    },
    hydration: {
      kicker: "YOUR TOP GOAL / SWEAT SUPPORT",
      title: "YOUR SIMPLE HYDRATION PLAN.",
      body: "Sweat and longer sessions matter most to you. MOVR gives you three key electrolytes plus 5g of creatine in one scoop.",
    },
    simplicity: {
      kicker: "YOUR TOP GOAL / EASY ROUTINE",
      title: "YOUR SIMPLE DAILY PLAN.",
      body: "The best plan for you is easy to repeat. MOVR puts 5g of creatine and three electrolytes into one daily lemon scoop.",
    },
  };

  function initQuiz(scope) {
    (scope || document)
      .querySelectorAll("[data-wellness-quiz]:not([data-initialized])")
      .forEach(function (quiz) {
        quiz.dataset.initialized = "true";
        const questionShell = quiz.querySelector("[data-quiz-questions]");
        const resultShell = quiz.querySelector("[data-quiz-results]");
        const optionsNode = quiz.querySelector("[data-quiz-options]");
        const promptNode = quiz.querySelector("[data-quiz-prompt]");
        const contextNode = quiz.querySelector("[data-quiz-context]");
        const iconNode = quiz.querySelector("[data-quiz-icon]");
        const stepNumber = quiz.querySelector("[data-quiz-step-number]");
        const progressLabel = quiz.querySelector("[data-quiz-progress-label]");
        const progressBar = quiz.querySelector("[data-quiz-progress-bar]");
        const back = quiz.querySelector("[data-quiz-back]");
        const next = quiz.querySelector("[data-quiz-next]");
        const nextLabel = quiz.querySelector("[data-quiz-next-label]");
        let step = 0;
        let selected = null;
        let answers = [];

        function renderQuestion() {
          const question = quizQuestions[step];
          promptNode.textContent = question.prompt;
          contextNode.textContent = question.context;
          const iconTemplate = quiz.querySelector(
            '[data-quiz-icon-template="' + question.icon + '"]',
          );
          if (iconTemplate)
            iconNode.replaceChildren(iconTemplate.content.cloneNode(true));
          stepNumber.textContent = String(step + 1).padStart(2, "0");
          progressLabel.textContent =
            "QUESTION " + (step + 1) + " OF " + quizQuestions.length;
          progressBar.style.width =
            ((step + 1) / quizQuestions.length) * 100 + "%";
          back.disabled = step === 0;
          next.disabled = selected == null;
          nextLabel.textContent =
            step === quizQuestions.length - 1
              ? "SEE MY ROUTINE"
              : "NEXT QUESTION";
          optionsNode.innerHTML = "";
          question.options.forEach(function (option, index) {
            const button = document.createElement("button");
            button.type = "button";
            button.className =
              "quiz-option" + (selected === index ? " selected" : "");
            button.setAttribute("role", "radio");
            button.setAttribute("aria-checked", String(selected === index));
            button.innerHTML =
              "<span>" +
              String.fromCharCode(65 + index) +
              "</span><span><b>" +
              escapeHtml(option.title) +
              "</b><small>" +
              escapeHtml(option.detail) +
              '</small></span><i aria-hidden="true"></i>';
            button.addEventListener("click", function () {
              selected = index;
              Array.from(optionsNode.children).forEach(
                function (optionButton, optionIndex) {
                  const active = optionIndex === selected;
                  optionButton.classList.toggle("selected", active);
                  optionButton.setAttribute("aria-checked", String(active));
                },
              );
              next.disabled = false;
            });
            optionsNode.appendChild(button);
          });
        }

        function completeQuiz() {
          const scores = { power: 0, hydration: 0, simplicity: 0 };
          answers.forEach(function (answerIndex, questionIndex) {
            const option = quizQuestions[questionIndex].options[answerIndex];
            Object.keys(scores).forEach(function (dimension) {
              scores[dimension] += option.scores[dimension];
            });
          });
          const dimensions = Object.keys(scores).sort(function (a, b) {
            return scores[b] - scores[a];
          });
          const total = Object.values(scores).reduce(function (sum, value) {
            return sum + value;
          }, 0);
          const percentages = {};
          let used = 0;
          dimensions.forEach(function (dimension, index) {
            const value =
              index === dimensions.length - 1
                ? 100 - used
                : Math.floor((scores[dimension] / total) * 100);
            percentages[dimension] = value;
            used += value;
          });
          const profile = quizProfiles[dimensions[0]];
          quiz.querySelector("[data-result-kicker]").textContent =
            profile.kicker;
          quiz.querySelector("[data-result-title]").textContent = profile.title;
          quiz.querySelector("[data-result-body]").textContent = profile.body;
          Object.keys(percentages).forEach(function (dimension) {
            const row = quiz.querySelector(
              '[data-score-row="' + dimension + '"]',
            );
            row.querySelector("i b").style.width = percentages[dimension] + "%";
            row.querySelector("strong").textContent =
              percentages[dimension] + "%";
          });
          questionShell.hidden = true;
          resultShell.hidden = false;
          window.scrollTo({
            top: Math.max(
              0,
              quiz.getBoundingClientRect().top + window.scrollY - 90,
            ),
            behavior: reduceMotion.matches ? "auto" : "smooth",
          });
        }

        next.addEventListener("click", function () {
          if (selected == null) return;
          answers[step] = selected;
          if (step === quizQuestions.length - 1) {
            completeQuiz();
            return;
          }
          step += 1;
          selected = answers[step] == null ? null : answers[step];
          renderQuestion();
        });
        back.addEventListener("click", function () {
          if (!step) return;
          step -= 1;
          selected = answers[step] == null ? null : answers[step];
          renderQuestion();
        });
        const restart = quiz.querySelector("[data-quiz-restart]");
        if (restart)
          restart.addEventListener("click", function () {
            step = 0;
            selected = null;
            answers = [];
            resultShell.hidden = true;
            questionShell.hidden = false;
            renderQuestion();
            window.scrollTo({
              top: Math.max(
                0,
                quiz.getBoundingClientRect().top + window.scrollY - 90,
              ),
              behavior: reduceMotion.matches ? "auto" : "smooth",
            });
          });
        renderQuestion();
      });
  }

  function initMotion(scope) {
    if (reduceMotion.matches || !("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 },
    );
    (scope || document)
      .querySelectorAll(".motion-section:not([data-motion-ready])")
      .forEach(function (section) {
        section.dataset.motionReady = "true";
        observer.observe(section);
      });
  }

  function initialize(scope) {
    initMenu();
    initCart();
    initProductGalleries(scope);
    initProductForms(scope);
    initReviews(scope);
    initQuiz(scope);
    initMotion(scope);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", function () {
      initialize(document);
    });
  else initialize(document);
  document.addEventListener("shopify:section:load", function (event) {
    initialize(event.target);
  });
})();
